import React, { useState } from 'react';
import Line from "./Line";
import DottedLine from "./DottedLine";

function Arrow({ startX, startY, endX, endY }) {
    const angle = Math.atan2(startY - endY, startX - endX) * (180 / Math.PI);
    const distance = Math.hypot(endX - startX, endY - startY);
    const angle1 = angle + 20;
    const angle2 = angle - 20;
    const arrowheadLength = 10;


    return (
      <>
        {/* Linia strzałki */}
        <DottedLine startX={endX} startY={endY} angle={angle} distance={distance} />
        {/* Linie groty */}
        <Line startX={endX} startY={endY} angle={angle1} distance={arrowheadLength} />
        <Line startX={endX} startY={endY} angle={angle2} distance={arrowheadLength} />
      </>
    );
}

export default Arrow;